var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcceptMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:email-tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.0834 39.5833C27.0834 32.6875 32.6876 27.0833 39.5834 27.0833C41.8751 27.0833 44.0001 27.7083 45.8334 28.7708V12.5C45.8334 11.3949 45.3944 10.3351 44.613 9.5537C43.8316 8.7723 42.7718 8.33331 41.6667 8.33331H8.33341C6.02091 8.33331 4.16675 10.1875 4.16675 12.5V37.5C4.16675 38.605 4.60573 39.6649 5.38714 40.4463C6.16854 41.2277 7.22835 41.6666 8.33341 41.6666H27.2709C27.1667 40.9791 27.0834 40.2916 27.0834 39.5833ZM8.33341 16.6666V12.5L25.0001 22.9166L41.6667 12.5V16.6666L25.0001 27.0833L8.33341 16.6666ZM36.9792 46.1666L31.2501 39.9166L33.6667 37.5L36.9792 40.8125L44.4584 33.3333L46.8751 36.2708L36.9792 46.1666Z",
    fill: "#F6931E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptMsg);
export default __webpack_public_path__ + "static/media/accept_msg.a7b8735dbc8a2c9865d95f16404686c9.svg";
export { ForwardRef as ReactComponent };